/**
 *Created by jmmartinez on 15/05/19
 * v.1.1  29/05/2019 Cambiado Formatear datos para sólo formatear si existe valor.
 * v.1.2  08/10/2019 Reestructuracion completa.
 *                   Generación de pdf en cliente.
 *
 * v.1.3  09/10/2019 Tomamos nombre de svg del parámetro
 * v.1.4  10/10/2019 Nueva funcion exportarPdfLocalEmpresaSvg con los datos de la empresa
 * v.1.45 10/10/2019 Eliminados exportarPdfLocal y exportarPdfLocalUI
 *                   Modificada coordenada Y del Svg a 55
 * v.1.5  04/11/2019 Añadido bloqueVariablesPdf
 *                   Uso de bloqueVariablesPdf en exportarPdfLocalEmpresaSvg.
 * v.1.6  06/11/2019 Modificada y del svg a yVariablesPDF + 10
 *                   Modificada scale del svg a 0.75
 *                   En el método getSVGHijo, si nombreSvg es barras, descendemos un nivel adicional
 * v.1.7  08/11/2019 Añadido método exportarExcelLocal
 * v.2.0  25/01/2021 En el metodo exportarPdfLocal, se añade un último parámetro onWillDrawCell, para modificar el pintado de la celda.
 * v.2.1  27/01/2021 En el método exportarPdfLocal, se añade un ultimo parámetro onDidParseCell, para modificar el fondo de las celdas.
 * v.2.2  03/02/2021 Renombrado exportarPdf a exportarPdfServidor
 *                   Renombrado exportarPDFLocal a exportarPdf
 *                   Modificados parámetros de entrada de exportarPdf a una clase.
 *                   Múltiples modificaciones internas de exportarPdf
 *                   Modificadas las llamadas al constructor GeneradorPdf para tomar los parámetros de pdfConfig
 */

import {
    servicioExportacion,
    servidor,
    sufijoExportacionExcel,
    sufijoExportacionPdf
} from "../../../dental/Configuracion";

import ClienteRestful from "../network/ClienteRestful";
import GeneradorPdf from "../pdf/GeneradorPdf";
import {generarColumnStyles, extraerColumnasTitulosEstilos, formatearDatos, extraerDatosValores, extraerDatosValoresPieEstilos, extraerPieDeDatos, extraerDatosParaExcel} from "../pdf/TableUtils";
import {getFormattedDateTimeFromDate} from "./DateUtils"

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

/*
  Definición de pdfConfig:
    {
    titulo:
    datos:
    columnas:
    stripped:
    nivel:
    svgs: [ {   svg:
                x:
                y:
                scale:
                titulo:
                tituloX:
                tituloY:
            }]
    }
    onAntesCierre:
 */

export const exportarPdf= (pdfConfig) => {
    console.log("EXPORT PDF LOCAL");

    let datosFormateados= null;
    let pieFormateado= null;
    let columnasFormateadas= null;
    let estilosColumnas= null;
    if (pdfConfig.datos && pdfConfig.columnas) {
        datosFormateados = extraerDatosValores(pdfConfig.datos, pdfConfig.columnas);
        pieFormateado = extraerDatosValoresPieEstilos(pdfConfig.datos, pdfConfig.columnas);
        columnasFormateadas = extraerColumnasTitulosEstilos(pdfConfig.columnas);
        estilosColumnas = generarColumnStyles(pdfConfig.columnas);
    }

    const generadorPdf= new GeneradorPdf(pdfConfig.orientacion, pdfConfig.tamagno);
    //generadorPdf.addText(0, 20, pdfConfig.titulo, 20, {align: 'center'}, "" );
    generadorPdf.addText(50, 20, pdfConfig.titulo, 20, {}, "" );

    //Gestionamos los niveles desde aquí, que es donde podemos acceder a los datos para ver el nivel
    let didParseCell = (data) => {
        if (Boolean(pdfConfig.nivel)) {
            let seccion = data.cell.section;
            let row = data.row.index;
            let linea = pdfConfig.datos[row];
            let nivel = linea.nivel;
            if (seccion === "body") {
                switch (nivel) {
                    case 1:
                        data.cell.styles.fillColor = [200, 200, 200];
                        data.cell.styles.fontStyle = "bold";
                        break;
                    case 3:
                        data.cell.styles.fontStyle = "bold";
                        break;
                }
            }
        }
        pdfConfig.onDidParseCell && pdfConfig.onDidParseCell(data);
    }

    let addTableYCierre= (pdfConfig, svgHeight) => {
        console.log("addTableYCierre");
        if (pdfConfig.datos && pdfConfig.columnas) {
            let y= 30;
            if (svgHeight)
                y = 40 + (svgHeight * generadorPdf.getConversorHeight());
            generadorPdf.addTable(0, y,
                datosFormateados, pieFormateado,
                columnasFormateadas, estilosColumnas,
                pdfConfig.stripped,
                pdfConfig.onWillDrawCell, didParseCell);
        }
        pdfConfig.onAntesCierre && pdfConfig.onAntesCierre(generadorPdf);
        generadorPdf.guardar(pdfConfig.titulo + ".pdf");
    }

    let addSvgTitulo= ( svg, svgWidth, svgHeight) => {
        let tituloX= svg.tituloX;
        let tituloY= svg.tituloY;
        if (!svg.tituloX ) {
            let textWidth = generadorPdf.getTextWidth(svg.titulo);
            tituloX = svg.x + (svgWidth / 2) - (textWidth / 2);
        }
        if (!svg.tituloY )
            tituloY= svg.y + svgHeight + 20;
        generadorPdf.addText(tituloX, tituloY, svg.titulo, 12);

    }

    if (pdfConfig.svgs && pdfConfig.svgs.length > 0){
        let svg0= pdfConfig.svgs[0];
        generadorPdf.addSvg(svg0.svg, {x: svg0.x, y: svg0.y, scale: svg0.scale, backgroundColor:"#ffffff", align: "left"},
            (width, height) => {
                addSvgTitulo(svg0, width * svg0.scale, height * svg0.scale);
                if (pdfConfig.svgs.length == 1) {
                    addTableYCierre(pdfConfig, height);
                }
                else{
                    let svg1= pdfConfig.svgs[1];
                    generadorPdf.addSvg(svg1.svg, {x: svg1.x, y:svg1.y, scale: svg1.scale, backgroundColor:"#ffffff", align: "left"},
                        (width, height) => {
                            addSvgTitulo(svg1, width * svg1.scale, height * svg1.scale);
                            addTableYCierre(pdfConfig, height);
                        }
                    );
                }
            }
        );
    }
    else {
        addTableYCierre(pdfConfig);
    }

}

export const exportarPdfLocalEmpresaSvg= (pdfConfig, titulo, datos, columnas, empresa, nombreSvg, variablesPDF) => {

    let datosFormateados= extraerDatosValores(datos, columnas);
    let pieFormateado= extraerDatosValoresPieEstilos(datos, columnas);
    let columnasFormateadas= extraerColumnasTitulosEstilos(columnas);
    let estilosColumnas= generarColumnStyles(columnas);
    const gPdf= new GeneradorPdf( pdfConfig ? pdfConfig.orientacion : null);

    gPdf.setFuente("Helvetica");

    let margenIzquierdo= 10;
    let margenDerecho= 10;
    if (empresa)
        bloqueEmpresaPdf(gPdf, empresa, margenIzquierdo, margenDerecho);

    gPdf.addText(0, 55, titulo, 20, {align: 'center'})

    let yVariablesPDF= 80;
    if (variablesPDF){
        yVariablesPDF= bloqueVariablesPdf(gPdf, variablesPDF, 80,  margenIzquierdo, margenDerecho)
    }

    if (nombreSvg) {
        console.log("EXPORTAR SVG");

        //console.log(yVariablesPDF);
        let elemento = document.querySelector("#" + nombreSvg);
        console.log(elemento);
        let svg = getSVGHijo(elemento, nombreSvg);
        //console.log(svg);

        //Obtenemos la escala:
        let svgWidth= svg.getAttribute("width");
        let pageWidth= gPdf.getPageSize().width;
        let scale= pageWidth / svgWidth;
        scale += 0.2;
        //scale=0.75;

        gPdf.addSvg(svg, {x: 0, y: yVariablesPDF + 10, scale: scale, backgroundColor: "#ffffff", align: "left"},
            (width, height) => {
                let y = yVariablesPDF + 10 + (height * gPdf.getConversorHeight());
                gPdf.addTable(0, y, datosFormateados, pieFormateado, columnasFormateadas, estilosColumnas);
                gPdf.guardar(titulo + ".pdf");
            }
        );
    }
    else{
        gPdf.addTable(0, yVariablesPDF, datosFormateados, pieFormateado, columnasFormateadas, estilosColumnas);
        gPdf.guardar(titulo + ".pdf");
    }
}

const bloqueEmpresaPdf= (gPdf, empresa, margenIzquierdo, margenDerecho) => {
    gPdf.addText( margenIzquierdo, 10, empresa.nombre, 8);
    gPdf.addText( margenIzquierdo, 20, empresa.domicilio + " " + empresa.poblacion + " " + empresa.cp + " " + empresa.provincia, 8);
    gPdf.addText( margenIzquierdo, 30, empresa.email + " " + empresa.web, 8);

    let cadenaAhora= getFormattedDateTimeFromDate(new Date());
    let cadenaFechaWidth = gPdf.getTextWidth(cadenaAhora);
    let cadenaFechaX = gPdf.getPageSize().width - margenDerecho - cadenaFechaWidth;
    gPdf.addText(cadenaFechaX, 10, cadenaAhora, 8);
}

const bloqueVariablesPdf= (gPdf, variablesPDF, y,  margenIzquierdo, margenDerecho) => {
    let separacionY= 12;
    let yActual= y;
    let anchoMaximo = gPdf.getPageSize().width  - (margenIzquierdo *2) - (margenDerecho*2);
    let anchoAcumuladoLinea = 0;
    variablesPDF.forEach ( (variable, item) => {
            let textoActual = variable.titulo + ": " + variable.valor;
            let anchoReal = gPdf.getTextWidth(textoActual)
            let anchoActual = anchoReal > variable.ancho || !variable.ancho ? anchoReal : variable.ancho;
            let separaciónEspacio= 0;
            if (anchoAcumuladoLinea > 0)
                separaciónEspacio= 10;

            if (anchoAcumuladoLinea + anchoActual + separaciónEspacio < anchoMaximo) { // +10 es por el separador
                let x= (margenIzquierdo*2) + anchoAcumuladoLinea + separaciónEspacio;
                gPdf.addText(x, yActual, textoActual, 12);
                anchoAcumuladoLinea += anchoActual + separaciónEspacio;
            }
            else {
                yActual += separacionY;
                let x= margenIzquierdo * 2;
                gPdf.addText(x, yActual, textoActual, 12);
                anchoAcumuladoLinea = anchoActual;
            }
        });
    return yActual + separacionY;
}

export const exportarPdfSvg= (pdfConfig) => {
    const generadorPdf= new GeneradorPdf(pdfConfig.orientacion, pdfConfig.tamagno);
    generadorPdf.addText(0, 20, pdfConfig.titulo, 20, {align: 'center'}, "" );

    let svg= pdfConfig.svgs[0];
    generadorPdf.addSvg(svg.svg, {x: svg.x, y: svg.y, scale: svg.scale, backgroundColor:"#ffffff"},
        (width, height) => {
            generadorPdf.guardar(pdfConfig.titulo + ".pdf");
            }
    );

}


export const exportarPdfServidor= (titulo, datos, columnas) => {
    const url= servidor + servicioExportacion + sufijoExportacionPdf;
    const parametros= {
        titulo: titulo,
        datos: formatearDatos(datos, columnas),
        pie: extraerPieDeDatos(datos, columnas),
        columnas: columnas
    }
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost( parametros, response => {
        if (response && response.ok) {
            console.log(response);
        }
    });
}

export const exportarExcel= (datos, columnas) =>{
    const url= servidor + servicioExportacion + sufijoExportacionExcel;
    const parametros= {
        datos: formatearDatos(datos, columnas),
        columnas: columnas
    }
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost( parametros, response => {
        if (response && response.ok) {
            console.log(response);
        }
        console.log(response);
    });
}


const getSVGHijo= (element, nombreSvg) => {

    element = element.firstChild;

    if (element)
        element = element.firstChild;

    if (element)
        element = element.firstChild;

    //Las barras están sumergidas un nivel adicional
    if (nombreSvg === "barras") {
        if (element) {
            element = element.firstChild;
        }
    }

    return element;
}



export const exportarExcelLocal= (datos, columnas) =>{

    console.log("ExportarExcelLocal");

    let datosFormateados= extraerDatosParaExcel(datos, columnas);
    console.log(datosFormateados);

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const ws = XLSX.utils.json_to_sheet(datosFormateados);
    const wb = { Sheets: { 'datos': ws }, SheetNames: ['datos'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(dataBlob, "datos" + fileExtension);

}

